module.exports = __webpack_public_path__ + "media/images/lb/515-ea3c467bcf2dbd0db3958a5c1e1e37ed.svg";